export default __webpack_public_path__ + "static/media/gd_1.2515e0a4.jpg";